<template>
  <div id="app">
    <component :is="layout">
      <router-view></router-view>
    </component>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

const defaultLayout = "default";

export default {
  name: "App",

  computed: {
    ...mapState(["dealer"]),
    layout() {
      return (this.$route.meta.layout || defaultLayout) + "-layout";
    },
  },

  methods: {
    ...mapActions("project", ["initWindowThreekitPlayer"]),
  },

  created() {
    this.initWindowThreekitPlayer();
  },
};
</script>

<style lang="scss">
$font-dir: "/fonts/";
@font-face {
  font-family: "Forza";
  src: url("#{$font-dir}Forza-Medium.otf");
}
@font-face {
  font-family: "ForzaBold";
  src: url("#{$font-dir}Forza-Bold.otf");
}
@font-face {
  font-family: "SlateStd";
  src: url("#{$font-dir}SlateStd.otf");
}
@font-face {
  font-family: "SlateStd-Light";
  src: url("#{$font-dir}SlateStd-Light.otf");
}
@font-face {
  font-family: "SlateStd-Bold";
  src: url("#{$font-dir}SlateStd-Bold.otf");
}

:root {
  --showroomColor: #0a80ed;
  --showroomColorHover: #0872d4;
  --showroomColorActive: #2b92f3;
  --playbookColor: #059c37;
  --playbookColorHover: #2faa4c;
  --playbookColorActive: #06c044;
  --snapsheetColor: #d5000b;
  --snapsheetColorHover: #bd060f;
  --snapsheetColorActive: #dd1e28;
  --buttonNotSelectedColor: #707070;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "SlateStd", Arial, sans-serif;
}

p {
  margin: 0;
}

#app {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  div,
  p,
  span,
  a,
  label,
  input,
  textarea,
  select {
    font-family: "SlateStd", Arial, sans-serif;
  }

  /* strong {
    font-family: "SlateStd-Bold", Arial, sans-serif;
  } */

  .slate {
    font-family: "SlateStd", arial, sans-serif;
  }
  .slate-light {
    font-family: "SlateStd-Light", arial, sans-serif;
  }
  .slate-bold {
    font-family: "SlateStd-Bold", arial, sans-serif;
  }
  .forza-bold {
    font-family: "ForzaBold", arial, sans-serif;
  }
  .text-grey-dark {
    color: $grey-dark;
  }
  .text-grey-light {
    color: $grey-light;
  }
  .text-placeholder {
    color: $placeholder;
  }
  button {
    border: 1px solid transparent;
    border-radius: 7px;
    cursor: pointer;
    transition: all 0.2s;
    &:not(.add-to-locker-button):hover {
      transform: scale(1.05);
    }
  }

  .btn {
    display: flex;
    align-items: center;
    padding: 0.5rem 1rem;
    text-align: center;
    justify-content: center;

    &.btn-black {
      background: $dark;
      color: white;
    }

    &.disabled,
    &:disabled {
      // pointer-events: none;
      cursor: not-allowed !important;
    }
  }

  .required {
    color: #fd397a;
  }
  .text-error {
    background: $red;
    color: whitesmoke;
    padding: 0.5rem;
    border-radius: 6px;
  }
  .hidden {
    display: none;
  }
  .kt-grid--root {
    justify-content: space-around;
    min-height: 100vh;
  }
  .full-width {
    width: 100%;
  }
  .flex {
    display: flex;
  }
  .flex-auto {
    flex: auto;
  }
  .flex-center,
  .justify-center {
    justify-content: center;
  }
  .flex-between,
  .justify-between {
    justify-content: space-between;
  }

  .justify-evenly {
    justify-content: space-evenly;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .flex-end,
  .justify-end {
    justify-content: flex-end;
  }
  .align-center {
    align-items: center;
  }
  .align-start {
    align-items: flex-start;
  }
  .align-end {
    align-items: flex-end;
  }
  .switch-group {
    display: flex;
    align-items: center;
  }
  .margin-0 {
    margin: 0;
  }
}

.sign-up-form {
  margin-top: 30px;
}

.forbidden {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.loading-spinner {
  margin: 50px 0;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toast-message {
  color: #fff;
}
@font-face {
  font-family: "Forza";
  src: url("#{$font-dir}Forza-Medium.otf");
}
@font-face {
  font-family: "ForzaBold";
  src: url("#{$font-dir}Forza-Bold.otf");
}
@font-face {
  font-family: "SlateStd";
  src: url("#{$font-dir}SlateStd.otf");
}
@font-face {
  font-family: "SlateStd-Bold";
  src: url("#{$font-dir}SlateStd-Bold.otf");
}
.tk-modal-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  background: rgba(255, 255, 255, 0.5);
  z-index: 100;
  .spinner-loader-container {
    margin: auto;
  }
}

.kt-spinner.kt-spinner--info:before {
  border: 3px solid #50ba73;
  border-right: 6px solid $grey-lightest;
}

#app {
  .text-center {
    text-align: center;
  }

  .full-width {
    width: 100%;
  }

  .m-auto {
    margin: auto;
  }

  .d-flex {
    display: flex;
  }

  .align-items-center {
    align-items: center;
  }
  .justify-center {
    justify-content: center;
  }

  .fade-in {
    animation: fadeIn ease 1s;
    -webkit-animation: fadeIn ease 1s;
    -moz-animation: fadeIn ease 1s;
    -o-animation: fadeIn ease 1s;
    -ms-animation: fadeIn ease 1s;
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-moz-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-o-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-ms-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .page {
    display: flex;
    flex-direction: column;
  }

  .home {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
    .page-loader {
      width: 100vw;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.15s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }

    .hidding-modal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #00000069;
      z-index: 1;
    }
  }

  .has-been-sent-message {
    text-align: center;
  }
  .toast-error {
    background-color: #bd362f;
    color: white !important;
    .toast-message {
      color: white !important;
    }
  }

  .flaticon2-add-1::before {
    color: white;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

#decorations-player {
  visibility: hidden;
  position: absolute;
  top: -100vh;
  left: -100vw;
  width: 100%;
  height: 100%;
}
</style>
